import script from "./createTag.vue?vue&type=script&lang=ts&setup=true"
export * from "./createTag.vue?vue&type=script&lang=ts&setup=true"

import "./createTag.vue?vue&type=style&index=0&id=2ac622b8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ac622b8"]])

export default __exports__